var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('toolbar'),_c('div',{attrs:{"height":_vm.$vuetify.breakpoint.xs ? '200px'
        : (_vm.$vuetify.breakpoint.sm ? '400px'
        : (_vm.$vuetify.breakpoint.md ? '600px'
        : (_vm.$vuetify.breakpoint.lg ? '800px' : '1000px'
        )))}},[(_vm.$vuetify.breakpoint.xs)?_c('div',[_c('div',{staticClass:"hidden-sm-and-up packhai-container-mobile"},[_c('router-view')],1)]):_c('v-main',[_c('v-container',{staticClass:"hidden-xs-only packhai-container"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }